import { ErrorMessage } from '.';

export interface InputField<T> {
    value: T;
    isValid: boolean;
    isEditable: boolean;
    errorMessages: ErrorMessage[];
}